var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hazard
    ? _c(
        "section",
        { staticClass: "uxo-item" },
        [
          !_vm.fetchingHazard
            ? [
                _vm.hazard.name
                  ? [
                      _c("h1", { staticClass: "mb-2" }, [
                        _vm._v(_vm._s(_vm.hazard.name))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column flex-lg-row mb-7" },
                        [
                          _c(
                            "div",
                            { staticClass: "uxo-item__gallery mb-4 mr-md-3" },
                            [
                              _vm.user &&
                              _vm.hazard.images.length >= 1 &&
                              (_vm.user.eod_technician ||
                                _vm.user.technical_interest)
                                ? [
                                    _c("cat-uxo-carousel", {
                                      staticClass: "mb-3",
                                      attrs: {
                                        "starting-image": 0,
                                        slides: _vm.images
                                      }
                                    })
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.user ||
                              (_vm.hazard.images.length > 0 &&
                                !_vm.user.eod_technician &&
                                  !_vm.user.technical_interest)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "uxo-list__image d-flex justify-content-center d-md-block"
                                    },
                                    [
                                      _vm.hazard.images[0]
                                        ? _c("img", {
                                            staticClass:
                                              "image w-auto align-self-center mb-3",
                                            attrs: {
                                              src: _vm.hazard.images[0].aws_url,
                                              alt: _vm.hazard.name
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.user &&
                              (_vm.user.eod_technician ||
                                _vm.user.technical_interest)
                                ? _c("cat-uxo-contribute", {
                                    attrs: {
                                      "contribution-model": _vm.hazard,
                                      user: _vm.user,
                                      button: "Contribute Information"
                                    }
                                  })
                                : _c(
                                    "a",
                                    {
                                      staticClass: "btn w-100",
                                      attrs: { href: "/sign-up" }
                                    },
                                    [
                                      _vm._v(
                                        "Sign-up to unlock additional content"
                                      )
                                    ]
                                  )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "uxo-item__content" }, [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "font-weight-normal uxo-item__section-heading"
                              },
                              [_vm._v("Description")]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "rich-content",
                              domProps: {
                                innerHTML: _vm._s(_vm.hazard.description_html)
                              }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.user
                        ? _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _vm.user &&
                              (_vm.user.eod_technician ||
                                _vm.user.technical_interest)
                                ? _c("cat-uxo-technical-information", {
                                    staticClass: "mb-10"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hazard.operation_html &&
                              (_vm.user.eod_technician ||
                                _vm.user.technical_interest)
                                ? _c(
                                    "div",
                                    { staticClass: "uxo-item__operation mb-3" },
                                    [
                                      _vm.hazard.operation_html
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "uxo-item__content uxo-item__content--full"
                                            },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  staticClass:
                                                    "uxo-item__section-heading"
                                                },
                                                [
                                                  _vm._v(
                                                    "Additional Information"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "rich-content",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.hazard.operation_html
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.user.eod_technician &&
                              _vm.hazard.eod_action_html
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "uxo-item__eod-action mb-3"
                                    },
                                    [
                                      _vm.hazard.eod_action_html
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "uxo-item__content uxo-item__content--full"
                                            },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  staticClass:
                                                    "uxo-item__section-heading"
                                                },
                                                [_vm._v("Possible EOD Action")]
                                              ),
                                              _vm._v(" "),
                                              _vm.hazard.eod_warning_html
                                                ? _c("div", {
                                                    staticClass:
                                                      "uxo-item__eod-warning p-4 border-radius shadow mb-3 rich-content",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.hazard
                                                          .eod_warning_html
                                                      )
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "rich-content",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.hazard.eod_action_html
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.user.eod_technician && _vm.hazard.notes_html
                                ? _c(
                                    "div",
                                    { staticClass: "uxo-item__notes mb-3" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "uxo-item__content uxo-item__content--full"
                                        },
                                        [
                                          _c(
                                            "h3",
                                            {
                                              staticClass:
                                                "uxo-item__section-heading"
                                            },
                                            [_vm._v("Notes")]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "rich-content",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.hazard.notes_html
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user &&
                      (_vm.user.eod_technician || _vm.user.technical_interest)
                        ? _c("cat-uxo-supporter-contributions", {
                            attrs: {
                              "contribution-model": _vm.hazard,
                              user: _vm.user
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("cat-uxo-linear-ads", { staticClass: "mb-10" }),
                      _vm._v(" "),
                      !_vm.user || (_vm.user && _vm.user.guest)
                        ? _c("div", { staticClass: "call-to-action-wrap" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-sm-flex columns justify-content-between mb-8"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex w-50 mr-sm-3 mb-3 mb-sm-0"
                                  },
                                  [
                                    _c("cat-uxo-call-to-action", {
                                      staticClass:
                                        "d-flex h-100 shape--uxo-item"
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "d-flex w-50" },
                                  [
                                    _c("cat-uxo-call-to-action-outline", {
                                      staticClass: "d-flex h-100"
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("cat-uxo-associated-hazards", {
                        staticClass: "mt-8",
                        attrs: { id: _vm.hazard.id }
                      }),
                      _vm._v(" "),
                      _vm.hazard.incidents.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "associated-associatedHazards mt-8"
                            },
                            [
                              _c(
                                "h2",
                                { staticClass: "t-orange text-center mb-3" },
                                [_vm._v("Associated Incidents")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "uxo-list columns is-multiline is-mobile mb-5"
                                },
                                [
                                  _vm._l(_vm.hazard.incidents, function(
                                    associatedIncident
                                  ) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "column is-4-mobile is-2-tablet mb-1"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "uxo-list__item",
                                              attrs: {
                                                href:
                                                  "/explosive-hazards/incidents/" +
                                                  associatedIncident.slug
                                              }
                                            },
                                            [
                                              associatedIncident.images &&
                                              associatedIncident.images[0]
                                                ? _c("img", {
                                                    staticClass:
                                                      "image border-radius mb-1",
                                                    attrs: {
                                                      src:
                                                        associatedIncident
                                                          .images[0].aws_url,
                                                      alt:
                                                        associatedIncident.name
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "font-weight-normal"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      associatedIncident.name
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hazard.terrorist_groups.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "associated-associatedHazards mt-8"
                            },
                            [
                              _c(
                                "h2",
                                { staticClass: "t-orange text-center mb-3" },
                                [_vm._v("Associated Terrorist Groups")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "uxo-list columns is-multiline is-mobile mb-5"
                                },
                                [
                                  _vm._l(_vm.hazard.terrorist_groups, function(
                                    associatedTerroristGroup
                                  ) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "column is-4-mobile is-2-tablet mb-1"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "uxo-list__item",
                                              attrs: {
                                                href:
                                                  "/explosive-hazards/terrorist-groups/" +
                                                  associatedTerroristGroup.slug
                                              }
                                            },
                                            [
                                              associatedTerroristGroup.images &&
                                              associatedTerroristGroup.images[0]
                                                ? _c("img", {
                                                    staticClass:
                                                      "image mb-1 border-radius",
                                                    attrs: {
                                                      src:
                                                        associatedTerroristGroup
                                                          .images[0].aws_url,
                                                      alt:
                                                        associatedTerroristGroup.name
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "font-weight-normal"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      associatedTerroristGroup.name
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  : [
                      _c("h2", [
                        _vm._v(
                          "The UXO you are looking for could not be found."
                        )
                      ])
                    ]
              ]
            : [
                _c(
                  "div",
                  { staticClass: "content-loader" },
                  [
                    _c(
                      "ContentLoader",
                      {
                        attrs: {
                          height: 56,
                          width: 720,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "5",
                            ry: "5",
                            width: "300",
                            height: "40"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ContentLoader",
                      {
                        staticClass: "mb-2",
                        attrs: {
                          height: 352,
                          width: 720,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "300",
                            height: "300"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "340",
                            y: "0",
                            rx: "5",
                            ry: "5",
                            width: "200",
                            height: "20"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "340",
                            y: "56",
                            rx: "5",
                            ry: "5",
                            width: "380",
                            height: "6.4"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "340",
                            y: "72",
                            rx: "5",
                            ry: "5",
                            width: "380",
                            height: "6.4"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "340",
                            y: "88",
                            rx: "5",
                            ry: "5",
                            width: "380",
                            height: "6.4"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "340",
                            y: "104",
                            rx: "5",
                            ry: "5",
                            width: "380",
                            height: "6.4"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "340",
                            y: "136",
                            rx: "5",
                            ry: "5",
                            width: "380",
                            height: "6.4"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "340",
                            y: "152",
                            rx: "5",
                            ry: "5",
                            width: "380",
                            height: "6.4"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "340",
                            y: "168",
                            rx: "5",
                            ry: "5",
                            width: "380",
                            height: "6.4"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "340",
                            y: "184",
                            rx: "5",
                            ry: "5",
                            width: "380",
                            height: "6.4"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "340",
                            y: "200",
                            rx: "5",
                            ry: "5",
                            width: "380",
                            height: "6.4"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "340",
                            y: "216",
                            rx: "5",
                            ry: "5",
                            width: "380",
                            height: "6.4"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "340",
                            y: "232",
                            rx: "5",
                            ry: "5",
                            width: "380",
                            height: "6.4"
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-638aa8fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638aa8fe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/uxo/Item.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-638aa8fe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/uxo/Item.vue
// module chunks = 0 1